export default __webpack_public_path__ + "static/media/01AW2AUG66.3dc69823.jpg";